<template>
    <div class="member-information">
      <div class="common-header-wrap">
        <mt-header title="个人信息" class="common-header">
          <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        </mt-header>
      </div>

      <div class="user-avatar iconfont icon-xiangji" @change="uploadImage($event)">
        <img :src="user.member_avatar">
        <input type="file" accept="image/*">
      </div>
      <div class="form">
        <mt-field class="menu-item" label="昵称" v-model="member_info.member_nickname" />
        <mt-field class="menu-item" label="QQ" v-model="member_info.member_qq" />
        <mt-field class="menu-item" label="旺旺" v-model="member_info.member_ww" />
        <div @click="onTime">
          <mt-cell class="menu-item"
                   title="出生日期"
                   :value="member_info.member_birthday"
                   is-link>
          </mt-cell>
        </div>
        <mt-button class="ds-button-large mt-10" type="primary" @click="submitInformation">保存</mt-button>
      </div>
      <mt-datetime-picker
              ref="timePicker"
              type="date"
              :startDate="new Date('1900/1/1')"
              :endDate="new Date()"
              :value="member_info.member_birthday?(new Date(member_info.member_birthday)):(new Date('1990/1/1'))"
              @confirm="timeConfirm"
      >
      </mt-datetime-picker>
      <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="裁剪图片" class="common-header">
            <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
            <mt-button slot="right" @click="useCrop">使用</mt-button>
          </mt-header>
        </div>
        <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
      </mt-popup>
    </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { uploadMemberAvatar, updateMemberInfo } from '../../../api/member'
export default {
  components: {
    VueCropper
  },
  name: 'MemberProfileSet',
  data () {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      member_info: {
        member_nickname: '',
        member_qq: '',
        member_ww: '',
        member_birthday: ''
      }
    }
  },
  mounted () {

  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  created: function () {
    if (this.user) {
      this.member_info.member_nickname = this.user.member_nickname
      this.member_info.member_qq = this.user.member_qq
      this.member_info.member_ww = this.user.member_ww
      this.member_info.member_birthday = this.user.member_birthday
    }
  },

  methods: {
    ...mapMutations({
      memberEdit: 'memberEdit'
    }),
    uploadImage (event) {
      let that = this
      let file = event.target.files[0]
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    },
    useCrop () {
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('memberavatar', files)
        Indicator.open()
        uploadMemberAvatar(formdata).then(res => {
          this.user.avatar = res.result + '?' + Math.floor(Math.random() * 100)
          this.memberEdit({ member_avatar: this.user.avatar })
          this.showCrop = false
          Indicator.close()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    timeConfirm (value) {
      this.member_info.member_birthday = value.getFullYear() + '/' + (value.getMonth() + 1) + '/' + value.getDate()
    },
    onTime (picker, values) {
      this.$refs.timePicker.open()
    },
    submitInformation () {
      updateMemberInfo(this.member_info).then(res => {
        this.memberEdit(this.member_info)
        Toast(res.message)
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>
<style  lang="scss" scoped>
  .member-information {
    background: #fff;
    .user-avatar {
      position: relative;
      width: 5rem;
      height: 5rem;
      margin: 2rem auto;
      text-align: center;
      img {
        width: 100%;
        height: 100%
      }
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0
      }
    }
    .user-avatar::before {
      position: absolute;
      font-size: 1.5rem;
      line-height: 5rem;
      left: 50%;
      margin-left: -.75rem;
      color: rgba(255, 255, 255, 0.5)
    }
    .menu-item {
      border-top: 1px solid #eee
    }
  }
</style>
